import React from 'react';
import { Fit, ImageSlot, ItemText, fs } from '../parts/fields';
import { Head, Logo } from '../parts/chrome';
import { img, items, useSlide } from '../parts/context';

// #region MaterialsLayout
/** One to four materials as cards: swatch or room photo, name, what it's for. */
export const MaterialsLayout: React.FunctionComponent = (): React.ReactElement => {
    const { slide } = useSlide();
    const list = items(slide.fields.items);
    const n = Math.max(1, list.length);
    const single = n === 1;
    // Every card's swatch is the same height; long copy gives up some of it so the words still fit at a readable size.
    const longest = list.reduce((m, it) => Math.max(m, (it.body ?? '').length + (it.title ?? '').length), 0);
    const imageHeight = (n <= 2 ? 420 : n === 3 ? 370 : 300) - (longest > 200 ? 90 : longest > 140 ? 45 : 0);
    return (
        <>
            <div className="wd-pad">
                <Head />
                <Fit style={{ flex: 1 }}>
                    <div style={{ display: 'grid', gridTemplateColumns: `repeat(${n}, minmax(0, 1fr))`, gap: n >= 4 ? 32 : 44, height: '100%' }}>
                        {list.map((it, i) => (
                            <article key={i} className="wd-card" style={{ display: 'flex', flexDirection: single ? 'row' : 'column', overflow: 'hidden', minWidth: 0 }}>
                                <ImageSlot fieldKey={`items.${i}.image`} image={img(it.image)} label="Add a swatch"
                                    style={single ? { width: 760, flex: 'none', borderRadius: 0 } : { height: imageHeight, flex: 'none', borderRadius: 0 }} />
                                <div className="wd-fit-watch" style={{ padding: n >= 4 ? '32px 32px 36px' : '40px 44px 44px', minWidth: 0, minHeight: 0, overflow: 'hidden', flex: 1, display: 'flex', flexDirection: 'column', justifyContent: single ? 'center' : 'flex-start' }}>
                                    <ItemText index={i} part="title" className="wd-h" style={{ fontSize: fs(single ? 56 : n >= 4 ? 32 : 38), lineHeight: 1.12 }} placeholder="Material" max={40} />
                                    <ItemText index={i} part="body" className="wd-lead wd-clamp" style={{ fontSize: fs(single ? 32 : n >= 4 ? 22 : 25), marginTop: 16, color: 'var(--wd-muted)' }} placeholder="Finish, feel and where it shines" max={220} />
                                </div>
                            </article>
                        ))}
                    </div>
                </Fit>
            </div>
            <Logo />
        </>
    );
};
